module.exports = __webpack_public_path__ + "257d4ed70f3b8d7e41a9623a3e4bcee4.ico";